import { useEffect } from "react";
import { faqs } from "@/mocks/gua";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import Weekly from "./components/Weekly";
import Monthly from "./components/Monthly";
import Collection from "./components/Collection";
import People from "./components/People";
import About from "./components/About";
import Faq from "./components/Faq";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";

const BASE_URL = "https://sdcmxx.cn";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertJsonLd(data: object, id: string) {
  document.getElementById(id)?.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export default function Home() {
  useEffect(() => {
    document.title = "最新吃瓜 - 近期热门事件盘点 | 本周瓜汇总·本月盘点·新近合集";
    upsertMeta("name", "description", "最新吃瓜近期热门事件一网打尽，本周瓜汇总、本月盘点、新近合集全收录。快速回顾近期最火的瓜和人物，补课吃瓜两不误。");
    upsertMeta("name", "keywords", "最新吃瓜,本周瓜汇总,近期事件,本月盘点,新近合集,近期热门");
    upsertMeta("name", "robots", "index, follow");

    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      const link = document.createElement("link");
      link.rel = "canonical";
      link.href = `${BASE_URL}/`;
      document.head.appendChild(link);
    }
    upsertMeta("property", "og:type", "website");
    upsertMeta("property", "og:site_name", "最新吃瓜");
    upsertMeta("property", "og:locale", "zh_CN");
    upsertMeta("property", "og:title", "最新吃瓜 - 近期热门事件盘点");
    upsertMeta("property", "og:description", "近期热门事件一网打尽：本周瓜汇总、本月盘点、新近合集全收录，高效补课吃瓜。");
    upsertMeta("property", "og:url", `${BASE_URL}/`);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:title", "最新吃瓜 - 近期热门事件盘点");
    upsertMeta("name", "twitter:description", "本周瓜汇总、本月盘点、新近合集一网打尽，近期热门事件轻松补课。");

    upsertJsonLd(
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "最新吃瓜",
        url: `${BASE_URL}/`,
        logo: `${BASE_URL}/logo.png`,
        description: "近期热门事件一网打尽，提供本周瓜汇总、本月盘点与新近合集。",
      },
      "ld-org"
    );
    upsertJsonLd(
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "最新吃瓜",
        url: `${BASE_URL}/`,
        inLanguage: "zh-CN",
        description: "最新吃瓜近期热门事件一网打尽，本周瓜汇总、本月盘点、新近合集全收录。",
        potentialAction: {
          "@type": "SearchAction",
          target: `${BASE_URL}/?s={search_term_string}`,
          "query-input": "required name=search_term_string",
        },
      },
      "ld-website"
    );
    upsertJsonLd(
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "近期热门事件盘点",
        url: `${BASE_URL}/`,
        inLanguage: "zh-CN",
        description: "本周瓜汇总、本月盘点与新近合集：快速回顾近期最火的瓜和人物。",
      },
      "ld-webpage"
    );
    upsertJsonLd(
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
      "ld-faq"
    );
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <Trending />
        <Weekly />
        <Monthly />
        <Collection />
        <People />
        <About />
        <Faq />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}